/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Mon Feb 22 2021 15:29:59 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { request } from '../utils/request';
import { API_URLS } from '../utils/config';
import prepareQueryParams from 'utils/prepareQueryParams';
let URL_: string;

const API_URL = API_URLS.FIN_ENGINE;
URL_ = `${API_URL}/api/fin-engine`;

// export function getApiVersion() {
//   return request.get<string>(
//     `${API_URL}/api/version`
//   );
// }
 
// async function getConfiguration() {
//     const version = await getApiVersion();
   
   
//     const configuration = await request.get(URL_);
//     return configuration;
 
// }
export interface ElementStep {
  ctesorder: number;
  ctesyear: number;
  ctesduration: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  ctesrentalamount: number;
  ctesoutstandingamount: number;
  ctesrentalcoef: number;
  ctesamortizedcoef: number;
}
export interface FinCalculationWithStepRequest {
  elementStep: Array<ElementStep>;

  inBillingDate: string;
  inCalculationMethod: string;
  inCountingbasis: string;
  inDeferredMethod: string;
  inDeferredRate: number;
  inDepositAmount: number;
  inDepositMethod: string;
  inDepositRate: number;
  inFinancedAmount: number;
  inFirstInstallmentDate: string;
  inInterestMethod: string;
  inPartAmount: number;
  inPartMethod: string;
  inPartNbDays: number;
  inPartRate: number;
  inPartInvoicingMode:string;
  inRatePeriodicity: number;
  inRateType: string;
  inRateValue: number;
  inRoundingAmount: number;
  inRoundingRate: number;
  inStartDate: string;
  inTaxcode: string;
  inTaxrate: number;
  inTaxtype: string;
  inTerm: string;
  inUpfrontAmount: number;
}

export interface FinCalculationRequest {
  inBillingDate: string;
  inCalculationMethod: string;
  inCalculationType: string;
  inCountingbasis: string;
  inDeferredMethod: string;
  inDeferredRate: number;
  inDepositAmount: number;
  inDepositMethod: string;
  inDepositRate: number;
  inDuration: number;
  inFinancedAmount: number;
  inFirstInstallmentDate: string;
  inFirstPayment: number;
  inGracePeriodDuration: number;
  inGracePeriodMethod: string;
  inInstallmentAmount: number;
  inInterestMethod: string;
  inPartAmount: number;
  inPartMethod: string;
  inPartNbDays: number;
  inPartRate: number;
  inPeriodicity: string;
  inPeriodicityUnit: string;
  inRatePeriodicity: number;
  inRateType: string;
  inRateValue: number;
  inResidualValue: number;
  inRoundingAmount: number;
  inRoundingRate: number;
  inStartDate: string;
  inTaxcode: string;
  inTaxrate: number;
  inTaxtype: string;
  inTerm: string;
  inUpFrontAmount: number;
  inFeesAmount?: number;
	inDealerPartAmount?: number;
	inManufacturerPartAmount?: number;
	inCommissionAmount?: number;
	inProfitabilityRate?: number;
	inFundingRate?: number;
	inFundingPeriodicity?:number; // 1; 2;...30..
	
	   inVatAmount?: number;
	    inVatDuration?: number;
	    inVatMethod?:string;
	    inVatDaysBasis?:string;

}

export interface AssetRVCalcParams {
  monthsmin: number;
  monthsmax: number;
  rvfixedamount: number;
  rvpercentage: number;
  trg: number;
  monthdecrease: number;
}

export interface IrvSchedule {
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}
export interface IrvCalculationRequest {
  inStartDate: string;
  inInvestAmount: number;
  inFinAmount: number;
  inAssetAmount: number;
  inRoundingAmount: number;
  inTerm: string;
  inBillingDate: string;
  assetRvCalcParams: Array<AssetRVCalcParams>;
  finSchedule: Array<PaymentSchedule>;
}

export interface IrvCalculationResult {
  success: boolean;
  message: string;

  IrvSchedule: Array<IrvSchedule>;
}

export interface CalculateSeasonalScheduleRequest {
  elementStep: Array<ElementStep>;
  inBillingDate: string;
  inCalculationMethod: string;
  inCountingbasis: string;
  inDeferredMethod: string;
  inDeferredRate: number;
  inDepositAmount: number;
  inDepositMethod: string;
  inDepositRate: number;
  inDuration: number;
  inFinancedAmount: number;
  inFirstInstallmentDate: string;
  inFirstPayment: number;
  inInterestMethod: string;
  inPartAmount: number;
  inPartMethod: string;
  inPartNbDays: number;
  inPartRate: number;
  inRatePeriodicity: number;
  inRateType: string;
  inRateValue: number;
  inResidualValue: number;
  inRoundingAmount: number;
  inRoundingRate: number;
  inStartDate: string;
  inTaxcode: string;
  inTaxrate: number;
  inTaxtype: string;
  inTerm: string;
  inUpFrontAmount: number;
}
export interface FinCalculationResult {
  deferredInterest: number;
  depositInterest: number;
  duration: number;
  effectiverate: number;
  financedamount: number;
  inBillingDate: string;
  inCalculationMethod: string;
  inCountingbasis: string;
  inDeferredMethod: string;
  inDeferredRate: number;
  inDepositAmount: number;
  inDepositMethod: string;
  inDepositRate: number;
  inDuration: number;
  inFinancedamount: number;
  inFirstInstallmentDate: string;
  inFirstPayment: number;
  inGracePeriodDuration: number;
  inGracePeriodMethod: string;
  inInstallmentAmount: number;
  inInterestMethod: string;
  inPartAmount: number;
  inPartMethod: string;
  inPartNbDays: number;
  inPartRate: number;
  inPeriodicity: number;
  inRatePeriodicity: number;
  inRateType: string;
  inRateValue: number;
  inResidualValue: number;
  inRoundingAmount: number;
  inRoundingRate: number;
  inStartDate: string;
  inTaxcode: string;
  inTaxrate: number;
  inTerm: string;
  inUpFront: number;
  installmentamount: number;
  message: string;
  nominalrate: number;
  elementStep: Array<ElementStep>;
  paymentSchedule: Array<PaymentSchedule>;
  fundingSchedule: Array<PaymentSchedule>;
  residualvalue: number;
  // new :
  effectivefundingRate: number;
  discountCoefficient: number;
  totalRental: number;
  totalInterest: number;
  totalAmortization: number;
  totaldiscountedInterest: number;
  totaldiscountedOutstanding: number;
  totaldiscountedAgiosdeb: number;
  totalAgiosdeb: number;
  totalVatDeffered: number;
  partAmount: number;
  commissionAmount: number;
  aprRate: number;
  profitabilityRate: number;
  dgo: number;
  marginImpactCredit: number;
  marginImpactDebit: number;
  flatRate: number;
  rate000: number;
  inFeesAmount: number;
  inDealerPartAmount: number;
  inManufacturerPartAmount: number;
  inCommissionAmount: number;
  inFundingRate: number;
  inFundingPeriodicity: number;
  fundingInstallment: number;
  inVatAmount: number;
  inVatDuration: number;
  inVatMethod: string;
  inVatDaysBasis: string;

  success: boolean;
}
export interface ServiceStep {
  steporder: number;
  stepunit: string;
  stepduration: number;
  deprpercentage: number;
  servpercentage: number;
  servamount: number;
}
export interface PaymentSchedule {
  ciid: number;
  cilid: number;
  cteid: number;
  ctesid: number;
  ctrid: number;
  ctsactuarialrate: number;
  ctsamortizedamount: number;
  ctsvatdeffered: number;
  ctsbasisamount: number;
  ctsbasisrate: number;
  ctsdepositbasis: number;
  ctsdepositinterest: number;
  ctsdepositrate: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  ctsinterestamount: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsperiodicity: string;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctsterm: string;
  ctstermlabel: string;
  ctstype: string;
  ctstypelabel: string;
  statuslabel: string;
  taxcode: string;
  taxcodelabel: string;
  ctstaxcode: string;
  ctstaxrate: number;
  ctstaxamount: number;
  ctstotalamount: number;
  ctsdiscountcoef: number;
  ctsdiscountoutstanding: number;
  ctsagiosdeb: number;

  ctsdiscountinterest: number;

  ctsdiscountagiosdeb: number;
}

export interface ServCalculationRequest {
  finSchedule: Array<PaymentSchedule>;
  inDownPayment: number;
  inFinAmount: number;
  inFollowGP: boolean;
  inGPDuration: number;
  inPstype: string;
  inRoudingAmount: number;
  inServcalculationmethod: string;
  inServfixedamount: number;
  inServiceduration: string;
  inServpercentage: number;
  inTaxcode: string;
  inTaxrate: number;
}

export interface ServCalculationWithStepRequest {
  finSchedule: Array<PaymentSchedule>;
  inDownPayment: number;
  inFinAmount: number;
  inFollowGP: boolean;
  inGPDuration: number;
  inPstype: string;
  inRoudingAmount: number;
  inServcalculationmethod: string;
  inServfixedamount: number;
  inServiceduration: string;
  inServpercentage: number;
  inTaxcode: string;
  inTaxrate: number;
  inDuration: number;
  inInvestAmount: number;
  inAssetAmount: number;
  inServperiodicity: string;
  inServDurationFree: number;

  inStartDate: string;
  inServbasis: string;

  inCalculatedamountbasis: string;

  inMarginoncalcultedamount: number;
  inAdditionalcostaftermargin: number;

  servStep: Array<ServiceStep>;
}

export interface CalculateParams {
  finReq: FinCalculationRequest;
}

export interface CalculateSpvParams {
  finReq: SpvCalculationRequest;
}

export interface SpvCalculationRequest {
  inDurationYears: number; // 1;2;....36... in nb of years
  inPeriodicity: number; // 1; 2;...30..
  inPeriodicityUnit: string; // D/M/A : Day / Month /Annual
  inResidualValue: number;
  inFirstPayment: number;
  inPower: number;
  inUnitPrice: number;
  inDiscountsale: number;
  inProduction: number;
  inDegradation: number;
  inInflation: number;
  inRoundingAmount: number;
  inRoundingRate: number;
  inTaxtype: string;
  inTaxcode: string;
  inTaxrate: number;
  inBillingDate: string;
  inStartDate: string;
  inFirstInstallmentDate: string;
}
export interface CalculatePaymentSheduleStepsParams {
  finReq: FinCalculationWithStepRequest;
}

export function calculateSpvSchedule(params: CalculateSpvParams) {
  return request.post<FinCalculationResult>(
    `${URL_}/v1/calculateSpvSchedule`,
    params.finReq
  );
}

/**
 * @tags Fin Engine Controller
 * @summary Calculate Financial element based requested attributes.
 */
export function calculate(params: CalculateParams) {
  return request.post<FinCalculationResult>(
    `${URL_}/v1/calculate`,
    params.finReq
  );
}

/**
 * @tags Fin Engine Controller
 * @summary Calculate Financial element based requested attributes.
 */
export function calculatePaymentSheduleSteps(
  params: CalculatePaymentSheduleStepsParams
) {
  return request.post<FinCalculationResult>(
    `${URL_}/v1/step-schedule-calculation`,
    params.finReq
  );
}




/**
 * @tags Fin Engine Controller
 * @summary Calculate Financial element based requested attributes.
 */
export function calculatePaymentShedulePrefinSteps(
  params: CalculatePaymentSheduleStepsParams
) {
  return request.post<FinCalculationResult>(
    `${URL_}/v1/prefin-step-schedule-calculation`,
    params.finReq
  );
}

export interface CalculatePaymentScheduleIFRSParams {
  inDuration: number;
  inFinancedamount: number;
  inInstallmentamount: number;
  inResidualvalue: number;
  inRoudingAmount: number;
  inRoudingRate: number;
  inStartDate: string;
}

/**
 * @tags Fin Engine Controller
 * @summary calculatePaymentScheduleIFRS
 */
export function calculatePaymentScheduleIFRS(
  params: CalculatePaymentScheduleIFRSParams
) {
  return request.post<Array<PaymentSchedule>>(
    `${URL_}/v1/ifrs-schedule-calculation` +
      prepareQueryParams({
        inDuration: params.inDuration,
        inFinancedamount: params.inFinancedamount,
        inInstallmentamount: params.inInstallmentamount,
        inResidualvalue: params.inResidualvalue,
        inRoudingAmount: params.inRoudingAmount,
        inRoudingRate: params.inRoudingRate,
        inStartDate: params.inStartDate,
      } as any)
  );
}

export interface CalculateSeasonalScheduleParams {
  finReq: CalculateSeasonalScheduleRequest;
}

/**
 * @tags Fin Engine Controller
 * @summary calculateSeasonalSchedule
 */
export function calculateSeasonalSchedule(
  params: CalculateSeasonalScheduleParams
) {
  return request.post<FinCalculationResult>(
    `${URL_}/v1/seasonal-schedule-calculation`,
    params.finReq
  );
}

export interface CalculateIRVScheduleParams {
  irvReq: IrvCalculationRequest;
}

export function calculateIRVSchedule(params: CalculateIRVScheduleParams) {
  return request.post<IrvCalculationResult>(
    `${URL_}/v1/irv-schedule-calculation`,
    params.irvReq
  );
}

export interface CalculateServiceParams {
  servReq: ServCalculationRequest;
}
export interface CalculateServiceWithStepParams {
  servReq: ServCalculationWithStepRequest;
}

/**
 * @tags Fin Engine Controller
 * @summary Calculate Service element based requested attributes.
 */
export function calculateService(params: CalculateServiceParams) {
  return request.post<FinCalculationResult>(
    `${URL_}/v1/services/calculate`,
    params.servReq
  );
}

export function calculateServiceWithStep(
  params: CalculateServiceWithStepParams
) {
  return request.post<FinCalculationResult>(
    `${URL_}/v1/service-step-calculation`,
    params.servReq
  );
}

export interface CalculatePaymentScheduleSPREADINGParams {
  inDuration: number;
  inFinancedamount: number;
  inRoudingAmount: number;
  inRoudingRate: number;
  inStartDate: string;
}

/**
 * @tags Fin Engine Controller
 * @summary calculatePaymentScheduleSPREADING
 */
export function calculatePaymentScheduleSPREADING(
  params: CalculatePaymentScheduleSPREADINGParams
) {
  return request.post<Array<PaymentSchedule>>(
    `${URL_}/v1/spreading-schedule-calculation` +
      prepareQueryParams({
        inDuration: params.inDuration,
        inFinancedamount: params.inFinancedamount,
        inRoudingAmount: params.inRoudingAmount,
        inRoudingRate: params.inRoudingRate,
        inStartDate: params.inStartDate,
      } as any)
  );
}
